<template>
  <b-card
    class="border mt-50 selected-items-card"
    no-body
  >
    <b-card-body class="p-1">
      <template v-for="item, itemIndex in items">
        <div
          :key="'item-' + idLabel === null ? itemIndex : item[idLabel]"
          class="d-flex justify-content-between align-items-center mx-1"
        >
          <div class="d-flex">
            <div
              v-if="variant === 'product'"
              class="selected-items-card__thumbnail align-self-center"
              :style="{ backgroundImage: 'url(' + item[imageLabel] + ')' }"
            />
            <b-avatar
              v-else-if="variant === 'avatar'"
              variant="transparent"
              class="selected-items-card__avatar align-self-center"
              size="50px"
              :src="item[imageLabel]"
            />
            <div class="selected-items-card__label align-self-center ml-1">
              {{ item[label] }}
            </div>
          </div>
          <b-button
            variant="link-secondary"
            class="selected-items-card__button"
            size="sm"
            @click="removeByItem ? removeItem(item) : removeItem(itemIndex)"
          >
            <GjIcon name="Delete" />
          </b-button>
        </div>
        <hr
          v-if="itemIndex < items.length-1"
          :key="'divider-' + idLabel === null ? itemIndex : item[idLabel]"
          class="selected-items-card__divider"
        >
      </template>
    </b-card-body>
  </b-card>
</template>
<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'

export default {
  components: {
    GjIcon,
  },
  props: {
    items: {
      type: [Array, Object],
      required: true,
    },
    label: {
      type: String,
      default: 'name',
    },
    imageLabel: {
      type: String,
      default: 'imageUrl',
    },
    idLabel: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: 'product',
    },
    removeByItem: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, context) {
    const removeItem = index => {
      context.emit('remove', index)
    }

    return { removeItem }
  },
}
</script>
<style lang="scss">
.selected-items-card {
    background-color: #fafafa;
    &__divider {
        border-color: #e2e2e2;
        margin: 8px 0;
    }
    &__thumbnail {
        display: inline-block;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        border-radius: 0.558rem;
        height: 44px;
        width: 54px;
    }
    &__avatar {
        background-color: #fafafa;
    }
    &__label{
        font-size: 14px;
        font-weight: 500;
        color: #052d61;
    }
    &__button {
        color: #B3B3B3;
        &:hover {
            color: #6e6b7b;
        }
    }
}
</style>
